module.exports = __webpack_public_path__ + "img/talent_sports.acf8bf8b.png";